module.exports = __webpack_public_path__ + "img/Empty-Search.de85f6f9.svg";